import React from 'react';

import DS_InfoGraphics from '../../../sections/DS_InfoGraphics';

/**
 * Render inline link in rich text
 *
 *
 * @returns {React.ReactElement}
 */
function EmbbeddEntryInfoGraphics(fields) {
  const { headline, infoGraphicCards, colorVariant, enumeration, layoutVariant, description } = fields;

  return (
    <div>
      {' '}
      <DS_InfoGraphics
        headline={headline}
        infoGraphicCards={infoGraphicCards}
        colorVariant={colorVariant}
        enumeration={enumeration}
        layoutVariant={layoutVariant}
        description={description}
        isRichText={true}
      ></DS_InfoGraphics>
    </div>
  );
}

export default EmbbeddEntryInfoGraphics;
